/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu May 04 2023
 **/

import { useEffect, useRef } from "react";

export default function OutsideClickDetector({
	id,
	children,
	active,
	onOutsideClick
}: {
	id: string;
	children: React.ReactNode;
	active: boolean;
	onOutsideClick?: (ev: MouseEvent) => void;
}) {
	const ref = useRef<HTMLDivElement>(null);

	const handleMouseDown = (ev: MouseEvent) => {
		const target = ev.target as Element;
		if (ref.current && !ref.current.contains(target)) {
			onOutsideClick && onOutsideClick(ev);
		}
	};

	useEffect(() => {
		if (!active) return;
		document.addEventListener("mousedown", handleMouseDown, true);
		return () => {
			document.removeEventListener("mousedown", handleMouseDown, true);
		};
	}, []);

	return (
		<div id={id} ref={ref}>
			{children}
		</div>
	);
}
